<template>
  <section>
    <BaseButton
      v-if="getSettings?.officeNumberPhone"
      @click="callToOffice"
      :bgColor="'#393945'"
      class="contact-button"
    >
      <div>
        <div class="button-continer gap-05">
          <img class="icon" src="/images/phone-icon.png" />
          <span>שיחה למשרד</span>
        </div>
      </div>
    </BaseButton>
    <BaseButton
      v-if="getSettings?.officeMailAddress"
      @click="mailToOffice"
      :bgColor="'#393945'"
      class="contact-button"
    >
      <div>
        <div class="button-continer gap-05">
          <img class="icon" src="/images/massage-icon.png" />
          <span>הודעה למשרד</span>
        </div>
      </div>
    </BaseButton>
    <BaseButton
      @click="whatsappToAgent"
      v-if="isValidAgentPhone"
      :bgColor="'#393945'"
      class="contact-button"
    >
      <div>
        <div class="button-continer gap-05">
          <img class="icon" src="/images/whatsApp-icon.png" />
          <span>הודעה לסוכן</span>
        </div>
      </div>
    </BaseButton>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import BaseButton from "../helpers/BaseButton.vue";
export default {
  components: {
    BaseButton,
  },
  computed: {
    ...mapGetters({
      getSettings: "Setting/getSettings",
      getAgentCust: "AuthModule/getAgentCust",
    }),
    isValidAgentPhone() {
      const agentPhone = this.getAgentCust?.contactphone;
      if (!agentPhone) return false;

      // Israeli mobile phone regex (supports formats: 05X-XXXXXXX or 05XXXXXXXX)
      const israeliPhoneRegex = /^05[0-9][0-9]{7}$/;
      // Clean the number from any non-digits
      const cleanNumber = agentPhone.replace(/\D/g, "");

      return israeliPhoneRegex.test(cleanNumber);
    },
  },
  methods: {
    callToOffice() {
      const officePhone =
        this.$store.getters["Setting/getSettings"].officeNumberPhone;
      window.open(`tel:${officePhone}`);
    },
    whatsappToAgent() {
      const agentPhone = this.getAgentCust.contactphone;
      // Clean the number from any non-digits
      const cleanNumber = agentPhone.replace(/\D/g, "");
      // Remove leading 0 and add 972 prefix
      const formattedNumber = cleanNumber.replace(/^0/, "");
      window.open(`https://wa.me/972${formattedNumber}`);
    },
    mailToOffice() {
      const officeMail =
        this.$store.getters["Setting/getSettings"].officeMailAddress;
      window.open(`mailto:${officeMail}`);
    },
  },
};
</script>

<style lang="scss" scoped>
section {
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
  justify-content: space-between;
}
.contact-button {
  width: 30vw;
  padding: 0px;
  min-width: 110px;
  height: 60px;
  border-radius: 20px;
  &:hover {
    cursor: pointer;
  }
  .button-continer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 10px;
  }
  span {
    font-size: $extraSmallTextSize;
  }
}
.icon {
  width: 22px;
  height: 22px;
}
</style>
